/* eslint-disable */
export default defineNuxtPlugin((_nuxtApp) => {
  const config = useRuntimeConfig()
  // TODO once tested, the condition can be changed to `if (process.env.DEPLOY_ENV !== 'production')` so pixel is
  // only loaded in the production environment
  if (process.env.DEPLOY_ENV === 'local') return
  ;((e, t, n) => {
    if (e.snaptr) return
    var a = (e.snaptr = function () {
      a.handleRequest ? a.handleRequest.apply(a, arguments) : a.queue.push(arguments)
    })
    a.queue = []
    var s = 'script',
      r,
      u
    r = t.createElement(s)
    r.async = !0
    r.src = n
    u = t.getElementsByTagName(s)[0]
    u.parentNode.insertBefore(r, u)
  })(window, document, 'https://sc-static.net/scevent.min.js')

  snaptr('init', config.public.snapchatPixelId)
  snaptr('track', 'PAGE_VIEW')

  // Track page views after router navigation
  const router = useRouter()
  router.afterEach((_to) => {
    window.snaptr('track', 'PAGE_VIEW')
  })
})
